const nsp = 'order/';

export const SET_ORDERS = `${nsp}SET_ORDERS`;
export const SET_ORDER_ITEM = `${nsp}SET_ORDER_ITEM`;
export const RESET_ORDER = `${nsp}RESET_ORDER`;
export const SET_UPDATED_ORDER_IN_LIST = `${nsp}SET_UPDATED_ORDER_IN_LIST`;
